// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details-container[data-v-1f104e49]{background-color:#fff;padding:48px 0 48px 98px}", ""]);
// Exports
module.exports = exports;
